import { HttpContextToken } from '@angular/common/http';

export const SKIP_SESSION_INTERCEPTOR = new HttpContextToken<boolean>(() => false);

/** Marks a request that already went through one silent re-login retry (avoids loops). */
export const AUTH_RETRIED = new HttpContextToken<boolean>(() => false);
